<template>
  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.80001 6.4C6.56732 6.4 8.00001 4.96731 8.00001 3.2C8.00001 1.43269 6.56732 0 4.80001 0C3.03269 0 1.60001 1.43269 1.60001 3.2C1.60001 4.96731 3.03269 6.4 4.80001 6.4Z" fill="currentColor" />
    <path d="M9.59306 13.1334L8.8667 8.59786C8.7851 7.80119 8.10034 7.2002 7.27638 7.2002H6.39962C6.18683 7.2002 5.98364 7.2825 5.83324 7.42693L4.79969 8.43014L3.76614 7.42693C3.61575 7.2825 3.41256 7.2002 3.19977 7.2002H2.32461C1.49905 7.2002 0.814286 7.80119 0.73429 8.57767L0.00632558 13.135C-0.022473 13.3555 0.0479233 13.5791 0.199916 13.7453C0.351909 13.913 0.569498 14.0093 0.799887 14.0093H1.66385L2.33261 14.6025C2.85655 15.6325 3.09898 16.0002 3.92454 16.0002H5.67645C6.50201 16.0002 6.91089 15.6325 7.26998 14.5886L7.93714 14.0093H8.7995C9.02989 14.0093 9.24748 13.913 9.39947 13.7453C9.55307 13.5791 9.62346 13.3555 9.59306 13.1334Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Account',
};
</script>
